<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div>
    <v-autocomplete
      v-model="newValue"
      :disabled="disableContexts"
      :search-input.sync="querySearch"
      label="Contexte(s) de vente"
      color="blue"
      menu-props="light"
      :item-text="getFieldText"
      :items="contexts"
      deletable-chips
      chips
      item-value="context"
      item-color="info"
      clearable
      multiple
      :rules="[v => v && v.length > 0 || 'Required']"
      @change="updateContextsListSelected"
      @input="querySearch = null"
    />
    <v-checkbox
      v-model="disableContexts"
      class="mt-0"
      label="Appliquer à tous les contexts"
      color="success"
      @change="changeDisableContexts"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

const props = defineProps({ value: { type: [Array], default: () => [] } });
const store = useStore();

const newValue = ref(props.value);
const querySearch = ref(null);
const disableContexts = ref(false);

const contexts = computed(() => store.getters.ruleContexts);

const emit = defineEmits(['input']);

watch(newValue, val => {
  // Updates v-model on the parent
  emit('input', val || null);
});

watch(contexts, () => {
  newValue.value = store.state.rules.contextsSelect;
});

const changeDisableContexts = enabled => {
  if (enabled) {
    newValue.value = ['*'];
    return;
  }
  newValue.value = [];
};

onMounted(() => {
  if (newValue.value && newValue.value.includes('*')) {
    disableContexts.value = true;
  }

  store.commit('setContextsSelect', props.value);
});

const getFieldText = item => `${item.label} | ${item.context}`;

const updateContextsListSelected = value => {
  newValue.value = value;
  store.commit('setContextsSelect', value);
};
</script>
